import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export interface WarehousesModel {
    isLoading: boolean;
    error: string;
    byId: {
        [id: string]: WarehouseModel;
    };
}

const initialState: WarehousesModel = {
    isLoading: false,
    error: "",
    byId: {},
};

const CustomWarehousesReducer = {
    // Get warehouse details
    "Custom/Warehouses/BeginLoadData": (draft: Draft<WarehousesModel>) => {
        draft.isLoading = true;
    },
    "Custom/Warehouses/LoadDataError": (
        draft: Draft<WarehousesModel>,
        action: {
            message: string;
        },
    ) => {
        draft.isLoading = false;
        draft.error = action.message;
    },
    "Custom/Warehouses/CompleteLoadData": (
        draft: Draft<WarehousesModel>,
        action: {
            result: WarehouseModel;
            warehouseId: string;
        },
    ) => {
        draft.isLoading = false;
        draft.byId[action.warehouseId] = action.result;
    },
};

export default createTypedReducerWithImmer(initialState, CustomWarehousesReducer);
